import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetReferralCodesResponseType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

const useGetReferralCodes = (): {
  getReferralCodesApi: UseMutateAsyncFunction<
    GetReferralCodesResponseType,
    unknown,
    {
      productCode: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
} => {
  const { paymentServices } = usePaymentServices();

  const getReferralCodes = ({ productCode }: { productCode: string }) => {
    return paymentServices.getReferralCodes({
      productCode
    });
  };

  const { mutateAsync, error, status } = useMutation(getReferralCodes, {
    mutationKey: ['getReferralCodesApi']
  });

  const getReferralCodesApi = mutateAsync;

  return {
    getReferralCodesApi,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetReferralCodes };
